<div class="toolbar">
    <ng-content select="fui-modal-window-toolbar"></ng-content>
</div>
<div class="view" [ngClass]="{'overlay':alert}">
    <div class="header">
        <ng-content select="fui-modal-window-header"></ng-content>
    </div>
    <div class="main">
        <ng-content select="fui-modal-window-main"></ng-content>
    </div>
    <div class="footer">
        <ng-content select="fui-modal-window-footer"></ng-content>
    </div>
</div>
<div class="alert" *ngIf="alert">
    <ng-content select="fui-modal-window-alert"></ng-content>
</div>
